import { apiGet, apiPatch } from './client';
import type { ProspectusExtraDetail, ProspectusExtraDetailBatchRequest } from '../types/ProspectusExtraDetail';

export function getProspectusExtraDetails(): Promise<ProspectusExtraDetail[]> {
  return apiGet<ProspectusExtraDetail[]>('/api/prospectus-extra-details');
}

export function saveBatchProspectusExtraDetails(
  added: ProspectusExtraDetail[],
  modified: ProspectusExtraDetail[],
  deletedIds: number[],
): Promise<ProspectusExtraDetail[]> {
  return apiPatch<ProspectusExtraDetailBatchRequest, ProspectusExtraDetail[]>('/api/prospectus-extra-details/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
